/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { InjectionToken } from "@angular/core";

export const ON_WEB_WORKER = new InjectionToken<boolean>("WebWorker.onWebWorker");
export const DEBUG: InjectionToken<string> = new InjectionToken<string>("WebWorker.Debug");
export const REGISTRY_CHANNEL: string = "__PROVIDER_WEBWORKER.Registry";
